//const uuid = require('uuid/v5'); //require("uuid-with-v6");
const slugid = require('slugid');

// Array.prototype.move = function(from, to) { this.splice(to, 0, this.splice(from, 1)[0]) };
// Array.prototype.clone = function() { return this.slice(0) }

/* Extend native Array. Not best practive, but at least it's done the right way (prototype, non enumerable) */
let proto = Array.prototype;
Object.defineProperty(proto, 'clone', {
  value: function() {
    return this.slice(0);
  },
  enumerable: false,
  configurable: true,
  writable: true // Konva JS
});

Object.defineProperty(proto, 'move', {
  value: function(from, to) {
    this.splice(to, 0, this.splice(from, 1)[0]);
  },
  enumerable: false,
  configurable: true,
  writable: true // Konva JS
});

// TODO: Don't export as defualt, so single functions can be imported

export default {
  isValidDate(dateString) {
    // TODO: move to moment or wrap moment
    console.warn("[DEPRECATED] isValidDate");
    let minDate = new Date('1970-01-01 00:00:01');
    let maxDate = new Date('2038-01-19 03:14:07');
    let date = new Date(dateString);
    return date > minDate && date < maxDate;
  },

  isValidId( id ) {
    // length slugid = 22, length pushid = 20
    return this.isString( id ) && id.length && id.length >= 20;
  },

  isString (obj) {
    return (Object.prototype.toString.call(obj) === '[object String]');
  },

  isNumeric(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
  },

  isValue(v) {
    return /* !isNaN(v) && */ v !== undefined && v !== null
  },

  isTimestamp(ts) {
    /* Could be further improved */
    return this.isNumeric(ts);
  },

  isFunction(f) {
    return (typeof f === "function");
  },

  isObject(o) {
    return typeof o === 'object' && o !== null;
  },

  isArray(a) {
    return Array.isArray( a );
  },

  isURL(str) {
    // Source: https://www.regextester.com/96504 -> Causes 2 min calculation for some URLS!
    // var regex = /(?:(?:https?|ftp):\/\/|\b(?:[a-z\d]+\.))(?:(?:[^\s()<>]+|\((?:[^\s()<>]+|(?:\([^\s()<>]+\)))?\))+(?:\((?:[^\s()<>]+|(?:\(?:[^\s()<>]+\)))?\)|[^\s`!()[]{};:'".,<>?«»“”‘’]))?/gi
    var regex = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([-.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/gi
    return regex.test(str);
  },

  arrayEqual(array1, array2) {
    return array1.length === array2.length &&
           array1.sort().every((value, index) => value === array2.sort()[index] );
  },

  arrayDiff( array1, array2 ) {
    return array1.filter(i => array2.indexOf(i) < 0 );
  },

  arrayDiffTwoWay( new_list, old_list ) {
    return {
      'removed': this.arrayDiff( old_list, new_list ),
      'added':   this.arrayDiff( new_list, old_list )
    }
  },

  /**
   * Partitions array in two array depencing on callback result
   *
   */
  partition(array, isValid) {
    return array.reduce(([ pass, fail ], element) => {
      return isValid( element )
        ? [ [ ...pass, element ], fail ]
        : [ pass, [ ...fail, element ] ];
    }, [ [], [] ]);
  },

  treatAsUTC(date) {
    // TODO: move to moment or wrap moment
    console.warn("[DEPRECATED] treatAsUTC");
    let result = new Date(date);
    result.setMinutes(result.getMinutes() - result.getTimezoneOffset());
    return result;
  },

  daysBetween(startDate, endDate) {
    // TODO: move to moment or wrap moment
    console.warn("[DEPRECATED] daysBetween");
    let millisecondsPerDay = 24 * 60 * 60 * 1000;
    return (this.treatAsUTC(endDate) - this.treatAsUTC(startDate)) / millisecondsPerDay;
  },

  goalsum(list) {
    return list.reduce((acc, obj) => acc + obj.size, 0);
  },

  listsum(list) {
    return list.reduce((acc, val) => acc + val, 0);
  },

  sorter: {
    by_rank(a, b) {
      if (a.rank < b.rank) return -1;
      if (a.rank > b.rank) return 1;
      return 0;
    },
    by_meta_sortidx(a, b) {
      if (a.meta.sortidx < b.meta.sortidx) return -1;
      if (a.meta.sortidx > b.meta.sortidx) return 1;
      return 0;
    },
    by_sortidx(a, b) {
      if (a.sortidx < b.sortidx) return -1;
      if (a.sortidx > b.sortidx) return 1;
      return 0;
    },
    by_ts(a, b) {
      if (parseInt(a.ts) < parseInt(b.ts)) return -1;
      if (parseInt(a.ts) > parseInt(b.ts)) return 1;
      return 0;
    },
    by_userStart(a, b) {
      if (+a.userStart < +b.userStart) return -1;
      if (+a.userStart > +b.userStart) return 1;
      return 0;
    },
    by_startDate(a, b) {
      if (+a.startDate < +b.startDate) return -1;
      if (+a.startDate > +b.startDate) return 1;
      return 0;
    },
    by_endDate(a, b) {
      if (+a.endDate < +b.endDate) return -1;
      if (+a.endDate > +b.endDate) return 1;
      return 0;
    },
    by_finishDate(a, b) {
      if (+a.finishDate < +b.finishDate) return -1;
      if (+a.finishDate > +b.finishDate) return 1;
      return 0;
    },
    by_createdAt(a, b) {
      if (+a.createdAt < +b.createdAt) return -1;
      if (+a.createdAt > +b.createdAt) return 1;
      return 0;
    },
    by_startedAt(a, b) {
      if (+a.startedAt < +b.startedAt) return -1;
      if (+a.startedAt > +b.startedAt) return 1;
      return 0;
    },
    by_from(a, b) {
      if (+a.from < +b.from) return -1;
      if (+a.from > +b.from) return 1;
      return 0;
    },
    by_start(a, b) {
      if (+a.start < +b.start) return -1;
      if (+a.start > +b.start) return 1;
      return 0;
    },
    by_user_prioidx(a, b) {
      if (a.user.prioidx < b.user.prioidx) return -1;
      if (a.user.prioidx > b.user.prioidx) return 1;
      return 0;
    },
    by_parent(a, b) {
      if (a.parent < b.parent) return -1;
      if (a.parent > b.parent) return 1;
      return 0;
    },
  },

  fieldSorter(fields) {
    var dir = [];
    var i = fields.length;
    var l = fields.length;
    fields = fields.map(function(o, i) {
      if (o[0] === "-") {
        dir[i] = -1;
        o = o.substring(1);
      } else {
        dir[i] = 1;
      }
      return o;
    });

    return function (a, b) {
      for (i = 0; i < l; i++) {
        var o = fields[i];
        if (a[o] > b[o]) return dir[i];
        if (a[o] < b[o]) return -(dir[i]);
      }
      return 0;
    };
  },

  getRandomInt() {
    return Math.floor(Math.random() * (50 - 5 + 1)) + 5;
  },

  getDate() {
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1;
    var yyyy = today.getFullYear();
    today = yyyy + "-" + ("0" + mm).slice(-2) + "-" + ("0" + dd).slice(-2);
    return today;
  },

  orderByProperty(prop) {
    var args = Array.prototype.slice.call(arguments, 1);
    return function(a, b) {
      if (a.constructor.name !== "Doc" || b.constructor.name !== "Doc") { // TODO: might not work in production
        return 0;
      }
      var equality = a[prop] - b[prop];
      if (equality === 0 && arguments.length > 1) {
        return this.orderByProperty.apply(null, args)(a, b);
      }
      return equality;
    };
  },

  /* function to save JSON to file from browser
  * adapted from http://bgrins.github.io/devtools-snippets/#console-save
  * @param {Object} data -- json object to save
  * @param {String} file -- file name to save to
  */
  saveJSON(data, filename) {
    if (!data) {
      console.error("No data");
      return;
    }

    if (!filename) filename = "console.json";

    if (typeof data === "object") {
      data = JSON.stringify(data, undefined, 4);
    }

    let blob = new Blob([data], { type: "text/json" });
    let e = document.createEvent("MouseEvents");
    let a = document.createElement("a");

    a.download = filename;
    a.href = window.URL.createObjectURL(blob);
    a.dataset.downloadurl = ["text/json", a.download, a.href].join(":");
    e.initMouseEvent(
      "click", true, false, window,
      0, 0, 0, 0, 0, false, false, false, false, 0, null
    );
    a.dispatchEvent(e);
  },

  /*
  * Source: https://stackoverflow.com/questions/23150333/html5-javascript-dataurl-to-blob-blob-to-dataurl
  */
  dataURLtoBlob(dataurl) {
    let arr = dataurl.split(',');
    let mime = arr[0].match(/:(.*?);/)[1];
    let bstr = atob(arr[1]);
    let n = bstr.length;
    let u8arr = new Uint8Array(n);

    while ( n-- ) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime });
  },

  /*
  * See saveJSON
  */
  generateDownloadFromBlob( blob, filename, format ) {
    let e = document.createEvent("MouseEvents");
    let a = document.createElement("a");
    a.download = filename;
    a.href = window.URL.createObjectURL(blob);
    a.dataset.downloadurl = [format, a.download, a.href].join(":");
    e.initMouseEvent(
      "click", true, false, window,
      0, 0, 0, 0, 0, false, false, false, false, 0, null
    );
    a.dispatchEvent(e);
  },

  /* -- FILTERS --  */
  pretty_state(data) {
    // let CircularJSON = require('flatted/esm');
    const { stringify } = require('flatted/cjs');
    return stringify(data, null, 2);
  },

  get_new_uuid() {
    // TODO: shorten uuid and check for existing ids
    return slugid.nice(); //uuid.v6();
  },

  showHoursMinutesSeconds(milliseconds) {
    // TODO: Duration plugin

    //milliseconds = parseFloat(milliseconds);
    let days = 0;
    let hours = 0;
    let min = 0;
    let sec = 0;
    if (milliseconds >= 0) {
      days = Math.floor(milliseconds / (60 * 60 * 24) / 1000);
      hours = Math.floor((milliseconds - days * 60 * 60 * 24 * 1000) / (60 * 60) / 1000);
      min = Math.floor((milliseconds - days * 60 * 60 * 24 * 1000 - hours * 60 * 60 * 1000) / 60 / 1000);
      sec = Math.floor((milliseconds - days * 60 * 60 * 24 * 1000 - hours * 60 * 60 * 1000 - min * 60 * 1000) / 1000);
      let time = ''
      if (days > 0 ) {
        time += days + 'd'
      }
      if (hours >= 10) {
        time += ' ' + hours + 'h'
      } else if (hours > 0 ) {
        time += ' 0' + hours + 'h'
      }
      if (min >= 10 ) {
        time += ' ' + min + 'm'
      } else if (min >= 0 ) {
        time += ' 0' + min + 'm'
      } else {
        time += ' 00m'
      }

      if (sec >= 10 ) {
        time += ' ' + sec + 's'
      } else if (min >= 0 ) {
        time += ' 0' + sec + 's'
      } else {
        time += ' 00s'
      }
      return time
    }
  },

  showDaysHoursMinutes(seconds) {
    // TODO: Move this to a filter / Use duration plugin
    let days = 0;
    let hours = 0;
    let min = 0;
    if (seconds >= 0) {
      days = Math.floor(seconds / (60 * 60 * 24) );
      hours = Math.floor((seconds - days * 60 * 60 * 24 * 1000) / (60 * 60) );
      min = Math.floor((seconds - days * 60 * 60 * 24 * 1000 - hours * 60 * 60 * 1000) / 60 );
      let time = ''
      if (days > 0 ) {
        time += days + 'd'
      }
      if (hours >= 10) {
        time += ' ' + hours + 'h'
      } else if (hours > 0 ) {
        time += ' 0' + hours + 'h'
      }
      if (min >= 10 ) {
        time += ' ' + min + 'm'
      } else if (min >= 0 ) {
        time += ' 0' + min + 'm'
      } else {
        time += ' 00m'
      }
      return time
    }
  },

  /*
  function get_color(color) {
    if ( color === 'default' ) {
      return "rgb(203, 232, 107)";
    }

    // Trick to get RGB values
    let d = document.createElement("div");
    d.style.color = color;
    document.body.appendChild(d);
    let color_rgb = window.getComputedStyle(d).color;
    document.body.removeChild(d);
    return color_rgb;
  }
  */

  createElementFromHTML( htmlString ) {
    var div = document.createElement('div');
    div.innerHTML = htmlString.trim();

    // Change this to div.childNodes to support multiple top-level nodes
    return div.firstChild;
  },

  /* Matches 'text !<x h|hour|hours><y m|min|mins><z s|sec|secs>' and returns
     results as { match, text, duration } */
  matchUserInputDuration(text) {
    var regex_match_group = /(\s*([0-9]+)\s*((hours|hour|h)|(mins|min|m)|(secs|sec|s)))+?/
    var regex_test = RegExp('^(.*)!(' + regex_match_group.source + ')$', 'gi')
    var regex_loop = RegExp(regex_match_group.source, 'gi');

    let match_test = regex_test.exec(text)
    if ( match_test !== null ) {
      text = match_test[2]
    } else {
      return { match: false, text, duration: null }
    }

    let result;
    let value_seconds = 0;
    while ((result = regex_loop.exec(text)) !== null) {
      var unit = (result[4] ? 3600 : 1)
               * (result[5] ?   60 : 1)
               * (result[6] ?    1 : 1)
      value_seconds += parseInt(result[2]) * unit;
    }
    return {
      match: true,
      text: match_test[1].trim(),
      duration: value_seconds
    }
  },

  /* Matches 'text !<x h|hour|hours><y m|min|mins><z s|sec|secs>' and returns
     duration in seconds, otherwise null (ES2018 version with named capture groups) */
  matchUserInputDurationES2018(text) {

    const regex_match_group = /(?<group>\s*(?<value>[0-9]+)\s*((?<unit_h>h|hour|hours)|(?<unit_m>m|min|mins)|(?<unit_s>s|sec|secs)))+/
    const regex_test = RegExp('^(?:.*)!(' + regex_match_group.source + ')$', 'gi')
    const regex_loop = RegExp(regex_match_group.source,'gi');

    let match_test = regex_test.exec(text)
    if ( match_test !== null ) {
      text = match_test[1]
    } else {
      return null
    }

    let result;
    let value_seconds = 0;
    while ((result = regex_loop.exec(text)) !== null) {
      var unit = (result.groups.unit_h ? 3600 : 1)
               * (result.groups.unit_m ?   60 : 1)
               * (result.groups.unit_s ?    1 : 1)
      value_seconds += parseInt(result.groups.value) * unit;
    }
    return value_seconds;
  }
};
